import Vue from 'vue'
import _ from 'lodash'
import bugsnag from '@/bugsnag'

function getInitialState () {
    return {
        groups: [],
        active: -1
    }
}

const state = getInitialState()

const mutations = {
    'INSERT_GROUP_LIST' (state, groups) {
        state.groups = _.unionBy(groups, state.groups, 'id')
    },
    'REMOVE_GROUP' (state, {group, index = null}) {
        // Check if we received an index
        if (index !== null && index < state.groups.length) {
            // Remove by index
            state.groups.splice(index, 1)
        } else if (index === null) {
            // Remove the specified group by id
            _.remove(state.groups, elem => elem.id === group.id)
        }
    },
    'INSERT_GROUP' (state, group) {
        // Set members to [] if its empty
        if (group.members === null || group.members === undefined) {
            group.members = []
        }

        // Insert the group if it doesn't exist
        state.groups = _.unionBy(state.groups, [group], 'id')
    },
    'INSERT_GROUP_MEMBER_LIST' (state, {group, members, index = null}) {
        // Fix faulty index
        if (index === null || index >= state.groups.length) {
            // Find the correct index
            index = _.indexOf(state.groups, group)
        }

        // Update the group if we found it
        if (index !== -1) {
            if (members === null || members === undefined) {
                members = []
            }

            state.groups[index].members = members
        }
    },
    'REMOVE_GROUP_MEMBER' (state, {group, member, index = null, memberIndex = null}) {
        // Find the index if necessary
        if (index === null || index >= state.groups.length) {
            // Find the correct index
            index = _.indexOf(state.groups, group)
        }

        // Get the group if we found it
        if (index !== -1) {
            // Get the members
            var members = state.groups[index].members

            // Find the member index if necessary
            if (memberIndex === null || index >= members.lenth) {
                memberIndex = _.indexOf(members, member)
            }

            if (memberIndex !== -1) {
                // Remove the member
                members.splice(memberIndex, 1)

                // Save the members to the group
                state.groups[index].members = members
            }
        }
    },
    'INSERT_GROUP_MEMBER' (state, {group, member, index = null}) {
        // Find the index if necessary
        if (index === null || index >= state.groups.length) {
            // Find the correct index
            index = _.indexOf(state.groups, group)
        }

        // Check if we have a group
        if (index !== -1) {
            // Check if we have members list
            if (state.groups[index].members === null) {
                state.groups[index].members = []
            }

            // Add the member to the list
            state.groups[index].members = _.unionBy(state.groups[index].members, [member], 'id')
        }
    },
    'UPDATE_GROUP_NAME' (state, {group, index = null}) {
        // Fix faulty index
        if (index === null || index >= state.groups.length) {
            // Find the correct index
            index = _.indexOf(state.groups, group)
        }

        // Update the group if we found it
        if (index !== -1) {
            state.groups[index] = group
        }
    },
    'SET_ACTIVE_GROUP' (state, {group, index = null}) {
        // Fix faulty index
        if (index === null || index >= state.groups.length) {
            // Find the correct index
            index = _.indexOf(state.groups, group)
        }

        // Update the active group index
        state.active = index
    },
    'GROUP_RESET' (state) {
        state = Object.assign(state, getInitialState())
    }
}

const actions = {
    group_list: ({commit}) => {
        Vue.http.get('groups').then(response => {
            commit('INSERT_GROUP_LIST', response.body.data)
        }).catch(error => {
            bugsnag.notify(JSON.stringify(error))
        })
    },
    group_post: ({commit}, name) => {
        Vue.http.post('groups', { name: name }).then(response => {
            commit('INSERT_GROUP', response.body.data)
        }).catch(error => {
            bugsnag.notify(JSON.stringify(error))
        })
    },
    group_put: ({commit}, {group, workarea = null}) => {
        Vue.http.put('group/' + group.id, { name: group.name, workarea }).then(resposne => {
            commit('UPDATE_GROUP_NAME', {group})
        }).catch(error => {
            bugsnag.notify(JSON.stringify(error))
        })
    },
    group_members: ({commit}, {group, index}) => {
        Vue.http.get('group/' + group.id + '/members').then(response => {
            commit('INSERT_GROUP_MEMBER_LIST', {group, members: response.body.data, index})
        }).catch(error => {
            bugsnag.notify(JSON.stringify(error))
        })
    },
    group_member_delete: ({commit}, {group, index, member, memberIndex}) => {
        Vue.http.delete('group/' + group.id + '/member/' + member.id).then(response => {
            commit('REMOVE_GROUP_MEMBER', {group, member, index, memberIndex})
        }).catch(error => {
            bugsnag.notify(JSON.stringify(error))
        })
    },
    group_member_post: ({commit}, {group, username, index}) => {
        Vue.http.post('group/' + group.id + '/members', { username: username }).then(response => {
            commit('INSERT_GROUP_MEMBER', {group, member: response.body.data, index})
        }).catch(error => {
            bugsnag.notify(JSON.stringify(error))
        })
    },
    group_delete: ({commit}, {group, index}) => {
        Vue.http.delete('group/' + group.id).then(response => {
            commit('REMOVE_GROUP', {group, index})
        })
    },
    group_select: ({commit}, {group, index}) => {
        commit('SET_ACTIVE_GROUP', {group, index})
    }
}

const getters = {
    getActiveGroup: state => {
        let group = state.groups[state.active]

        if (group !== undefined && (group.members === undefined || group.members === null)) {
            group.members = []
        }

        return group
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/group.js